/* eslint-disable react/no-unescaped-entities */
import { FooterSite, HeaderSite } from '@acme/feature';
import React, { useEffect } from 'react';

const PrivacyPolicy = () => {
    useEffect(() => {
        document.documentElement.classList.remove('dark');
        document.body.classList.remove('dark');
    }, []);

    return (
        <div className="flex flex-col min-h-screen bg-gradient-to-r from-blue-800 to-blue-500">
            {/* Header */}
            <HeaderSite />

            {/* Content */}
            <main className="container px-4 lg:px-20 py-16 text-white flex-grow flex flex-col justify-start">
                <h2 className="text-4xl font-bold mb-6">
                    Privacy Policy
                </h2>

                <div className=''>
                    <ol>
                        <li>
                            {/** // eslint-disable-next-line react/no-unescaped-entities **/}
                            <p>Introduction Our company ("We," "Our," or "Us") values the privacy of our users. This Privacy Policy outlines the types of information we collect, how we use it, and the steps we take to protect your privacy when you use our SaaS application and associated services.</p>
                        </li>
                        <li>
                            <p>Information Collection and Use We collect and use the following types of information: a. Personal Information: We may collect personal information such as name, email address, and API keys when you register for an account or use our services. b. Usage Data: We collect data about your usage of our services, such as the content you generate and the features you access. c. Cookies: We use cookies and similar technologies to track your activity on our website and to remember your preferences.</p>
                        </li>
                        <li>
                            <p>Information Sharing and Disclosure We do not sell, trade, or rent your personal information to third parties. We may share your information only in the following situations: a. With your consent. b. To provide and maintain our services. c. To comply with legal obligations or to protect our rights and interests.</p>
                        </li>
                        <li>
                            <p>Data Security We take the security of your personal information seriously and implement appropriate measures to protect your data from unauthorized access, disclosure, or destruction. However, no method of data transmission or storage is completely secure, and we cannot guarantee absolute security.</p>
                        </li>
                        <li>
                            <p>Third-Party Links Our services may contain links to third-party websites or services that are not owned or controlled by us. We are not responsible for the privacy practices or content of these third-party websites or services.</p>
                        </li>
                        <li>
                            <p>Changes to Privacy Policy We reserve the right to update or modify this Privacy Policy at any time. Any changes will be posted on this page, and we encourage you to review our Privacy Policy periodically.</p>
                        </li>
                        <li>
                            <p>Contact Us If you have any questions or concerns about this Privacy Policy, please contact us at [your contact email address].</p>
                        </li>
                    </ol>
                </div>
            </main>

            {/* Footer */}
            <FooterSite />
        </div >
    );
};

export default PrivacyPolicy;
